<template lang="pug">
.section
  .section-header
    .section-header-back
      a.btn.btn-sm.btn-icon(href="javascript:void(0)" @click="redirect()")
        i.fas.fa-arrow-left
    h1 {{ $t("ui.sub_account") }}
    .section-header-breadcrumb
      .breadcrumb-item
        router-link(to="/account/subAccount") {{ $t("ui.sub_account") }}
      .breadcrumb-item.active
        span {{ $t('ui.combine.add_sub_account') }}
  .section-body
    .row
      .col-12
        .card.mb-0
          //- small {{ filteredAuthorities.join(',') }}
          b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
            .card-header
              .row.w-100
                .form-group.col-3.mb-1
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      span {{ prefix }}
                    DebounceInput(
                      size="sm"
                      ref="login_id"
                      required
                      alphaNum
                      type="text"
                      :dirty="$v.login_id.$dirty"
                      :error="$v.login_id.$error"
                      v-model.trim.lazy="$v.login_id.$model"
                      :disabled="loading"
                      :maxLength="$v.login_id.$params.maxLength.max"
                    )
                  ValidateResult(:value="$v.login_id" :name="$t('ui.login_id')")
                .form-group.col-3.mb-1
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      span {{ $t('ui.password') }}
                    DebounceInput(
                      size="sm"
                      required
                      type="password"
                      :dirty="$v.password.$dirty"
                      :error="$v.password.$error"
                      v-model.trim.lazy="$v.password.$model"
                      :disabled="loading"
                    )
                  ValidateResult(:value="$v.password" :name="$t('ui.password')")
                .form-group.col-3.mb-1
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      span {{ $t('ui.confirm_password') }}
                    DebounceInput(
                      size="sm"
                      required
                      type="password"
                      :dirty="$v.confirm_password.$dirty"
                      :error="$v.confirm_password.$error"
                      v-model.trim.lazy="$v.confirm_password.$model"
                      :disabled="loading"
                    )
                  ValidateResult(:value="$v.confirm_password" :name="$t('ui.confirm_password')", :name2="$t('ui.password')")
            .card-body
              .row
                .col-12(v-if="isMaster || isOperator")
                  b-form-group(:label="$t('ui.role_settings')")
                    .btn-group
                      button.btn.btn-warning(
                        type="button"
                        v-for="(label, key) in roles"
                        :key="key"
                        :class="{ active: selectedRole === key }"
                        @click="selectRole(key)"
                      ) {{ label }}
                      //- button.clear-button(
                      //-   v-if="selectedRole"
                      //-   @click="clearSelection"
                      //- ) Clear Selection
                    //- p(v-if="selectedRole") Selected Role: {{ roles[selectedRole] }}
                    //- p(v-else) No Role Selected
                .col-12
                  b-form-group(:label="$t('ui.authority_option')")
                    .row
                      //- .col-sm-12.col-md-3.col-lg-3(v-if="isAdmin")
                      //-   authorityPanel(category="general" @select-all="rowSelectAll")
                      .col-sm-12.col-md-3.col-lg-3
                        authorityPanel(category="website" @select-all="rowSelectAll" :updateKey="updateKey")
                      .col-sm-12.col-md-3.col-lg-3(v-if="isOperator")
                        authorityPanel(category="operation_management" @select-all="rowSelectAll" :updateKey="updateKey")
                      .col-sm-12.col-md-3.col-lg-3(v-if="isOperator")
                        authorityPanel(category="game_management" @select-all="rowSelectAll" :updateKey="updateKey")
                      .col-sm-12.col-md-3.col-lg-3(v-if="isOperator")
                        authorityPanel(category="member_management" @select-all="rowSelectAll" :updateKey="updateKey")
                      .col-sm-12.col-md-3.col-lg-3(v-if="isOperator")
                        authorityPanel(category="promotion_management" @select-all="rowSelectAll" :updateKey="updateKey")
                      .col-sm-12.col-md-3.col-lg-3(v-if="!isOperator")
                        authorityPanel(category="account" @select-all="rowSelectAll" :updateKey="updateKey")
                      .col-sm-12.col-md-3.col-lg-3(v-if="!isOperator")
                        authorityPanel(category="operator" @select-all="rowSelectAll" :updateKey="updateKey")
                      template(v-if="cpiEnable")
                        .col-sm-12.col-md-3.col-lg-3(v-if="getCpiDetails || !isOperator")
                          authorityPanel(category="cpi" @select-all="rowSelectAll" :updateKey="updateKey")
                      .col-sm-12.col-md-3.col-lg-3
                        authorityPanel(category="memberreport" @select-all="rowSelectAll" :updateKey="updateKey" isView=true)
                      .col-sm-12.col-md-3.col-lg-3
                        authorityPanel(category="ticket" @select-all="rowSelectAll" :updateKey="updateKey")
                      .col-sm-12.col-md-3.col-lg-3
                        authorityPanel(category="ticketvoucher" @select-all="rowSelectAll" :updateKey="updateKey")
                      .col-sm-12.col-md-3.col-lg-3(v-if="!isOperator")
                        authorityPanel(category="global" @select-all="rowSelectAll" :updateKey="updateKey")
                      .col-sm-12.col-md-3.col-lg-3
                        authorityPanel(category="report" @select-all="rowSelectAll" :updateKey="updateKey" isView=true)
                      .col-sm-12.col-md-3.col-lg-3
                        authorityPanel(category="log" @select-all="rowSelectAll" :updateKey="updateKey" isView=true)
                      //- .col-sm-12.col-md-3.col-lg-3(v-if="isOperator")
                      //-   authorityPanel(category="risk_management" @select-all="rowSelectAll")
                      .col-sm-12.col-md-3.col-lg-3
                        authorityPanel(category="affiliate_management" @select-all="rowSelectAll" :updateKey="updateKey")
                      .col-sm-12.col-md-3.col-lg-3
                        authorityPanel(category="free_credit_provider" @select-all="rowSelectAll" :updateKey="updateKey")
                      .col-sm-12.col-md-3.col-lg-3(v-if="isAdmin")
                        authorityPanel(category="content" @select-all="rowSelectAll" :updateKey="updateKey")
                      .col-sm-12.col-md-3.col-lg-3
                        authorityPanel(category="action" @select-all="rowSelectAll" :updateKey="updateKey" isView=true)
                      .col-sm-12.col-md-3.col-lg-3
                        authorityPanel(category="actionaff" @select-all="rowSelectAll" :updateKey="updateKey" isView=true)
                .col-12
                  SubmitButton(:loading="loading" icon="fa fa-ban" :text="$t('ui.cancel')" size="xs" variant="danger" type="button" isModal=false @click="cancel()")
                  SubmitButton.ml-1(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" size="xs" variant="success" isModal=false @click="submit()")
                  
</template>

<script>
import { required, alphaNum, minLength, maxLength, integer, email, sameAs, helpers } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";
import authority from "@/authority";
import authorityOpr from "@/authorityOpr";
const containAlphaNum = helpers.regex("containAlphaNum", /^(?=.*\d)(?=.*[a-zA-Z])/);
import authorityPanel from "@/components/subAccount/authorityList"; 

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput,
    authorityPanel
  },
  data() {
    return {
      loading: false,
      feedback: {
        success: true,
        status: ""
      },
      login_id: "",
      password: "",
      confirm_password: "",
      rolesOperator: {
        op_customerservice: this.$t("ui.customer_services"),
        op_marketing: this.$t("ui.marketing"),
        op_finance: this.$t("ui.finance")
      },
      rolesMaster: {
        ma_customerservice: this.$t("ui.customer_services"),
        ma_payment: this.$t("ui.payment"),
        ma_riskmanangement: this.$t("ui.risk_management"),
        ma_finance: this.$t("ui.finance")
      },
      selectedRole: null,
      authority_list: [],
      updateKey: 0,
      isUat: config.isUat
    };
  },
  computed: {
    masterCustomerServiceRole() {
      return config.masterCustomerServiceRole;
    },
    masterPaymentRole() {
      return config.masterPaymentRole;
    },
    masterRiskManangementRole() {
      return config.masterRiskManagementRole;
    },
    masterFinanceRole() {
      return config.masterFinanceRole;
    },
    operatorCustomerServiceRole() {
      return config.operatorCustomerServiceRole;
    },
    operatorMarketingRole() {
      return config.operatorMarketingRole;
    },
    operatorFinanceRole() {
      return config.operatorFinanceRole;
    },
    isAdmin() {
      return this.$store.getters.accountType === 5;
    },
    isAdminMaster() {
      return [3,5].includes(this.$store.getters.accountType);
    },
    isMaster() {
      return [3].includes(this.$store.getters.accountType);
    },
    isOperator() {
      return [2].includes(this.$store.getters.accountType);
    },
    operatorID() {
      return this.$store.getters.selectedOperatorID
    },
    prefix() {
      if (this.$store.getters.accountId)
        return this.$store.getters.accountId + '@';

      return '';
    },
    filteredAuthorities() {
      return this.authority_list
        .filter(item => item.checked) // Filter only where checked is true
        .map(item => {
          if(!this.isOperator) {
          } else {
          }

          if (item.edit) {
            // If both checked and edit are true, combine value and editValue
            return `${item.value},${'e_'+item.value}`;
          } else {
            // If only checked is true, return the value
            return item.value;
          }
        });
    },
    roles() {
      if(this.isMaster) {
        return this.rolesMaster
      }
      if(this.isOperator) {
        return this.rolesOperator
      }
      return []
    },
    // authority_list() {
    //   return this.isOperator ? authorityOpr.list : authority.list;
    // }
    getCpiDetails() {
      return this.$store.getters.cpiDetails;
    },
    getAuthOriginalChecked() {
      return this.$store.getters.authOriginalChecked;
    },
    cpiEnable() {
      return config.cpiEnable == "1";
    },
    getCurrencyCode() {
      return this.$store.getters.currencyCode;
    },
    fundTransferEnable() {
      return config.fundTransferEnable == "1";
    }
  },
  mounted: function() {
    this.reset();
  },
  validations: {
    login_id: {
      required,
      alphaNum,
      minLength: minLength(2),
      maxLength: maxLength(20)
    },
    password: {
      required,
      containAlphaNum,
      minLength: minLength(6),
      maxLength: maxLength(50)
    },
    confirm_password: {
      required,
      sameAs: sameAs("password")
    }
  },
  beforeDestroy() {
    this.closed();
  },
  methods: {
    selectRole(key) {
      this.selectedRole = this.selectedRole === key ? null : key; // Toggle selection

      switch(key) {
        case "ma_customerservice":
          this.authority_list.forEach((item) => {
            if(this.selectedRole) {
              item.checked = this.masterCustomerServiceRole.includes(item.value);
              item.edit = this.masterCustomerServiceRole.includes('e_' + item.value);
            } else {
              item.checked = false;
              item.edit = false;
            }
          });
          break;
        case "ma_payment":
          this.authority_list.forEach((item) => {
            if(this.selectedRole) {
              item.checked = this.masterPaymentRole.includes(item.value);
              item.edit = this.masterPaymentRole.includes('e_' + item.value);
            } else {
              item.checked = false;
              item.edit = false;
            }
          });
          break;
        case "ma_riskmanangement":
          this.authority_list.forEach((item) => {
            if(this.selectedRole) {
              item.checked = this.masterRiskManangementRole.includes(item.value);
              item.edit = this.masterRiskManangementRole.includes('e_' + item.value);
            } else {
              item.checked = false;
              item.edit = false;
            }
          });
          break;
        case "ma_finance":
          this.authority_list.forEach((item) => {
            if(this.selectedRole) {
              item.checked = this.masterFinanceRole.includes(item.value);
              item.edit = this.masterFinanceRole.includes('e_' + item.value);
            } else {
              item.checked = false;
              item.edit = false;
            }
          });
          break;
        case "op_customerservice":
          this.authority_list.forEach((item) => {
            if(this.selectedRole) {
              item.checked = this.operatorCustomerServiceRole.includes(item.value);
              item.edit = this.operatorCustomerServiceRole.includes('e_' + item.value);
            } else {
              item.checked = false;
              item.edit = false;
            }
          });
          break;
        case "op_marketing":
          this.authority_list.forEach((item) => {
            if(this.selectedRole) {
              item.checked = this.operatorMarketingRole.includes(item.value);
              item.edit = this.operatorMarketingRole.includes('e_' + item.value);
            } else {
              item.checked = false;
              item.edit = false;
            }
          });
          break;
        case "op_finance":
          this.authority_list.forEach((item) => {
            if(this.selectedRole) {
              item.checked = this.operatorFinanceRole.includes(item.value);
              item.edit = this.operatorFinanceRole.includes('e_' + item.value);
            } else {
              item.checked = false;
              item.edit = false;
            }
          });
          break;
      }
    },
    clearSelection() {
      this.selectedRole = null;
    },
    redirect() {
      // this.$store.dispatch("user/setSelectedOperatorID", "");
      this.$router.push("/account/subAccount");
    },
    selectedRow: function(info) {
      if (info.checked)
        return true;

      return false;
    },
    rowSelectAll(isSelected, dataList) {
      dataList.forEach(item => {
        item.checked = isSelected;
        item.edit = isSelected;
      });

      this.updateKey = this.updateKey + 1
    },
    submit: function() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let url = config.accountSubAddUrl();

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          login_id: this.prefix + this.login_id,
          password: this.password,
          // authority_option: this.authority_list.filter(item => { return item.checked == true}).map(i => i.value).join(','),
          authority_option: this.filteredAuthorities.join(',') + (this.isOperator ? ',operator,e_operator,settings,operatorsetting' : ''),
          audit_by: this.$store.getters.loginId,
          account_id: this.$store.getters.accountId
        };

        this.feedback.success = true;
        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.loading = false;
            // Success
            try {
              if (response) {
                if (typeof response.data.status == "string") {
                  this.feedback.success = response.data.status == "1";
                } else {
                  this.feedback.success = response.data.status == 1;
                }
                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  this.$helpers.showDialog(this.$t("ui.combine.add_sub_account"), this.$t("message.success"), "success");
                  this.$router.push("/account/subAccount")
                } else {
                  this.$helpers.handleFeedback(this.feedback.status);
                  this.$helpers.showDialog(this.$t("ui.combine.add_sub_account"), this.$t("error." + this.feedback.status), "error");
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        );
      }
    },
    reset: function() {
      this.$v.$reset();
      this.login_id = "";
      this.password = "";
      this.confirm_password = "";
      this.feedback.success = true;
      this.feedback.status = "";
      this.authority_list = this.isOperator ? authorityOpr.list : authority.list;
      if(this.isUat == 'false') {
        if(!['BDT'].includes(this.getCurrencyCode)) {
          this.authority_list = this.authority_list.filter(d => { return d.value != 'pendingbetlist9w' })
        } else {
          this.authority_list = this.authority_list.filter(d => { return d.value != 'pendingbetlistothers' })
        }
        if(!this.fundTransferEnable) {
          this.authority_list = this.authority_list.filter(d => { return d.value != 'ftprovider' })
        }
      }

      if(!this.isAdmin) {
        this.authority_list = this.authority_list.filter(d => { return d.value != 'clearoutstandinglog'})
      }

      this.$refs.login_id.$el.focus();

      // this.authority_list.map(function(x) {
      //   x.checked = false;
      //   x.edit = false;
      //   // if(x.hasOwnProperty("edit")) {
      //   //   x.edit = false;
      //   // }
      //   return x;
      // });

      // create Map for quick lookup
      // Map key = value of item, value = the original item object
      const checkedMap = new Map(
        this.getAuthOriginalChecked.map(item => [item.value, item])
      );

      this.authority_list.forEach(item => {
        // try to find a matching checked item in the Map
        const match = checkedMap.get(item.value);

        if (match) {
          item.checked = match.checked;
          item.edit = match.edit;
        } else {
          item.checked = false;
          item.edit = false;
        }
      });
    },
    cancel() {
      this.reset()
      this.$router.push("/account/subAccount")
    },
    closed: function() {
      this.authority_list.map(function(x) {
        x.checked = false;
        x.edit = false;
        return x;
      });
    }
  }
};
</script>
